import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthGate } from './components/AuthGate';
import { AppRecovery } from './components/AppRecovery';
import { ApiError } from './lib/api';
import { installAttachmentLinks } from './lib/attachmentLinks';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      refetchOnWindowFocus: false,
      // Retry transient/server failures once; fail fast on deterministic 4xx.
      retry: (failureCount, err) => {
        const status = err instanceof ApiError ? err.status : undefined;
        return failureCount < 1 && (status === undefined || status >= 500);
      },
    },
  },
});

// Apply persisted dark-mode / reduced-motion preferences before first paint.
if (localStorage.getItem('atlas.theme') === 'dark') document.documentElement.classList.add('dark');
if (localStorage.getItem('atlas.reduceMotion') === '1') document.documentElement.classList.add('reduce-motion');

// Rewrite permissioned attachment links/images to short-lived signed URLs so
// direct browser access (new-tab opens, inline <img> loads) is authenticated.
installAttachmentLinks();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRecovery><AuthGate>
          <App />
        </AuthGate></AppRecovery>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
